import styled from 'styled-components';

export const Wrapper = styled.div`
	.content {
		padding: 1rem 2rem;
		position: relative;
	}
	.content-item {
		/* border-bottom: 1px solid #A8A8B1; */
		padding-left: 1rem;
		/* width: 80%; */
	}
	@media (max-width: 960px) {
		.content {
			padding: 0 1rem 1rem 1rem;
			.content-item {
				padding-left: 0;
				width: 100%;
			}
		}
	}
`;

export const FormWrapper = styled.div`
	width: ${(props) => props.width || '450px'};
    margin: 1rem 3rem 1rem 0rem;
	.w-50 {
		width: 450px;
	}
	.w-100 {
		width: 100% !important;
	}
	.mt-1 {
		margin-top: 0.5rem !important;
	}
	.mb-1 {
		margin-bottom: 0.5rem !important;
	}
	.m-2 {
		margin: 1rem;
    }
    .medium-width {
        width: 250px;
    }
	.payment-icon {
		margin: 0.5rem;
		width: 3rem;
	}
	.d-flex {
		display: flex;
	}
	.content-text-medium {
		font-size: 12px;
	}
	.content-text-small {
		font-size: 11px;
	}
	.content-text-mini {
		font-size: 10px;
	}
	.head {
		font-weight: bold;
	}
	.description-wrapper {
		border-bottom: 0px !important;
		padding-bottom: 10px !important;
	}
	.ant-form-item.last {
		border-bottom: 0;
		padding: 0;
	}
	.ant-radio-group {
		width: 100%;
		margin-top: 21px;
		&.sub-radio {
			margin-top: 12px;
		}
	}
	.ant-radio-wrapper {
		display: block;
        padding: 24px 12px;
        
        .ant-btn {
            font-size: 32px;
            height: auto;
            position: absolute;
            right: 10px;
            top: 10px;
        }
	}
	.ant-radio-wrapper-checked {
		border: 1px solid #0000ff;
    }
    .theme-create-btn {
        .ant-btn {
            font-size: 32px;
            height: auto;
        }
    }

    .file-wrapper {
        margin-bottom: 3rem;
        .ant-form-item-control {
			line-height: 1;
		}
    }
	.file-container {
		border: 1px solid #b9b9b9;
		display: block;
		padding: 0 8px;
		padding-left: 90px;

		margin-top: 12px;
		white-space: nowrap;
		position: relative;
		img {
			position: absolute;
			top: 0px;
			left: 0px;
			display: block;
			width: 90px;
			height: 86px;
			object-fit: fill;
			cursor: pointer;
		}
		.ant-spin {
			position: absolute;
			top: 25px;
			left: 25px;
		}
		label {
			display: block;
			padding: 12px;
			padding-bottom: 0;
			box-sizing: border-box;
			height: 86px;
			border-left: 1px solid #b9b9b9;
			.anchor {
				color: #3A4FFF;
				text-decoration: underline;
				cursor: pointer;
			}
		}
		.ant-form-item-control {
			line-height: 1;
		}
		input {
			opacity: 0;
			position: fixed;
			left: -999px;
		}
		&::after {
			content: '';
			display: table;
			clear: both;
		}
    }
    .ant-btn-block {
        margin-top: 1rem;
		/* min-width: fit-content;
		width: 50%; */
		width: 250px;
   		height: 35px;
    }
	.btn-area {
		border: 1px solid #3A4FFF;
		margin-top: 8px;
		display: flex;
		> * {
			flex: 1;
		}
		.local {
			line-height: 1;
		}
		.ant-btn-primary {
			border: 0px;
			width: 250px;
   			 height: 35px;
		}
		button {
			font-weight: normal !important;
		}
    }
    .sub-heading-label {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 0.25rem;
		color: #ffffff
	}
	.section-wrapper {
		color: #ffffff;
		/* border-bottom: 1px solid #A8A8B1; */
		/* padding: 2rem 0; */
		margin-bottom: 1rem;
		.ant-form,.quick-restart-card {
			 background-color: #212121;
      	 	 padding: 2rem 3rem;
		}
	}
    .activation-code {
        // margin: 2rem 0;
        border-bottom: 0px;
		background-color: #212121;
      	padding: 2rem 3rem;
        .code-visible {
            background-color: none;
        }
        .code-hidden {
			background-color: #ffffff;
        }
    }
    .divider {
        border-top: 1px solid #000000;
        margin: 2rem 0;
        width: 100%
	}
	.requirement-icon {
		margin-right: 0.25rem;
		width: 1rem;
	}
	.toggle-wrapper {
		width: 150px;
		text-align: center;

		.toggle-menu {
			font-size: 9px;
			margin-left: 5px;
			margin-Right: 5px;
			color: #B3B3B3;
		}
		.active {
			color: #000000;
		}
	}
	.bottom-description {
		margin-top: 1rem;
	}
	.link {
		color: #3A4FFF;
		text-align: center;
		span {
			cursor: pointer;
		}
	}
	.ant-input {
    border: 1px solid #A8A8B1;
    border-radius: 5px;
    font-size: 12px;
    background-color: #41454D;
    color: #A8A8B1;
	}
	.ant-input:focus-within {
		background-color: #29292C;
	}
	.ant-input[disabled] {
    color: #A8A8B1;
    background-color: #42454D;
    cursor: not-allowed;
    opacity: 0.5;
	}
	@media (max-width: 960px) {
		width: 100%;
		.section-wrapper {
			padding-top: 0;
		}
	}
	@media (max-width: 425px) {
		.section-wrapper {
			.flex-container {
				flex-direction:column;
			}
			.ant-form {
				padding: 1rem 1.5rem;
			}
			.medium-width {
				width: 100%;
			}
			.ant-btn-block {
					width: 100%;
			}
		}
	}
`;